import queryString from 'query-string';
import { useRouter } from 'next/router';

type Props = {
    equipmentTitle?: string;
    slug: string;
};

export const useGoTo = () => {
    const router = useRouter();

    return {
        goToAuction: ({ auctioneerSlug, auctionSlug }) => {
            const pathname = `/auctioneer/${auctioneerSlug}/${auctionSlug}`;

            void router.push(pathname);
        },
        goToAuctioneer: ({ auctioneerSlug }) => {
            const pathname = `/auctioneer/${auctioneerSlug}`;

            void router.push(pathname);
        },
        goToDealer: ({ dealerSlug }) => {
            void router.push(`/dealer/${dealerSlug}`);
        },
        goToDealerWebsite: (website: string) => {
            let url = website.startsWith('http') ? website : 'https://' + website;

            if (!url.includes('?')) {
                url += '?';
            } else {
                url += '&';
            }

            window.open(`${url}utm_source=tractorzoom.com&utm_medium=referral`, '_blank');
        },
        goToEquipment: ({ slug }: Props) => {
            void router.push(`/equipment/${slug}`);
        },
        goToEquipmentNewTab: ({ slug }: Props) => {
            window.open(`/equipment/${slug}`, '_blank');
        },
        goToLocation: ({ dealerSlug, locationSlug }) => {
            void router.push(`/dealer/${dealerSlug}/${locationSlug}`);
        },
        goToSearch: (params) => {
            void router.push(`/search?${queryString.stringify(params)}`);
        },
    };
};
